class SearchModal extends HTMLElement {
    constructor() {
        super();
        this.modalCloseButton = this.querySelector('[data-asset="search-modal-close"]');
        this.body = document.querySelector('body');
    }

    connectedCallback() {
        const $this = this;
        document.querySelectorAll('button[data-asset="search-button"]').forEach((button) => {
          button.addEventListener('click', $this.handleSearchButtonClickEvent.bind(this));
        })
        this.modalCloseButton.addEventListener('click', this.handleSearchCloseButtonClickEvent.bind(this));
    }

    handleSearchButtonClickEvent(event) {
        this.body.classList.add('search-modal-loaded', 'search-modal-visible');
    }

    handleSearchCloseButtonClickEvent(event) {
        this.body.classList.remove('search-modal-loaded', 'search-modal-visible');
    }
}
customElements.define('search-modal', SearchModal);

class LocalizationSelectorsForm extends HTMLElement {
     constructor() {
        super();
        this.localizationDataDisclosureToggleButton = this.querySelector('[data-disclosure-toggle]');
        this.disclosureList = this.querySelector('[data-disclosure-list]');
        this.disclosureOptions = this.querySelectorAll('[data-disclosure-option]');
        this.localizationForm = this.querySelector('#localization_form');
        this.disclosureInput = this.querySelector('[data-disclosure-input]');
    }

     connectedCallback() {
        const localCurrency = this.dataset.localCurrency;
        const configuredCurrenciesString = this.dataset.configuredCurrencies;

        if (!configuredCurrenciesString.includes(localCurrency)) {
          this.submitLocalizationForm("GB")
        }
       
        this.localizationDataDisclosureToggleButton.addEventListener('click', this.handleLocalizationDataDisclosureToggleButton.bind(this));

        for (var i = 0; i < this.disclosureOptions.length; i++) {
          var option = this.disclosureOptions[i];
          option.addEventListener('click', this.handleLocalizationOptionClickEvent.bind(this));
        }

        document.addEventListener('click', (event) => {
          if (!this.localizationDataDisclosureToggleButton.contains(event.target) && this.disclosureList.classList.contains('disclosure-list--visible')) {
             this.localizationDataDisclosureToggleButton.click();
          }
        });
    }

    handleLocalizationOptionClickEvent(event) {
      this.submitLocalizationForm(event.currentTarget.dataset.value);
    }

    submitLocalizationForm(value) {
      this.disclosureInput.value = value;
      this.localizationForm.submit();
    }

    handleLocalizationDataDisclosureToggleButton(event) {
        var ariaExpanded = event.currentTarget.getAttribute('aria-expanded') === 'true';
        event.currentTarget.setAttribute('aria-expanded', !ariaExpanded);

        if (this.disclosureList.classList.contains('disclosure-list--visible')) {
          this.disclosureList.classList.remove('disclosure-list--visible');
        } else {
          this.disclosureList.classList.add('disclosure-list--visible');
        }
    }
}
customElements.define('localization-selectors-form', LocalizationSelectorsForm);


(() => {
  class FeaturedCollectionTab {
    constructor() {
      this.tabLinks = null;
      this.tabCollections = null;
      this.section = null;
    }

    register(section) {
      this.section = section;
      this.tabLinks = this.section.querySelectorAll('[data-featured-collection-tab-link]');
      this.tabCollections = this.section.querySelectorAll('[data-featured-collection]');
      this._initEvents();
    }

    _initEvents() {
      this.tabLinks?.forEach(link => {
        link.addEventListener('click', (event) => this.handleLinkClickEvent(event));
      });
    }

    handleLinkClickEvent(event) {
      event.preventDefault();
      const link = event.currentTarget;
      const targetId = link.getAttribute('href').replace('#', '');
      this.tabLinks.forEach(tabLink => tabLink.classList.remove('active'));
      this.tabCollections.forEach(tabCollection => tabCollection.classList.remove('active'));
      link.classList.add('active');
      const targetSection = document.getElementById(targetId);
      if (targetSection) {
        targetSection.classList.add('active');
      }
    }
  }

  const featuredCollectionsAsTabSections = document.querySelectorAll('[data-featured-collections-as-tabs]');
  featuredCollectionsAsTabSections.forEach(section => {
    const featuredCollectionTab = new FeaturedCollectionTab();
    featuredCollectionTab.register(section);
  });
})();

(() => {
  class Accordion {
    constructor(el) {
      this.el = el;
      this.summary = el.querySelector('summary');
      this.content = el.querySelector('.collapsible-tab__text');
      this.animation = null;
      this.isClosing = false;
      this.isExpanding = false;
      this.summary.addEventListener('click', (e) => this.onClick(e));
    }
  
    onClick(e) {
      e.preventDefault();
      this.el.style.overflow = 'hidden';
      if (this.isClosing || !this.el.open) {
        this.open();
      } else if (this.isExpanding || this.el.open) {
        this.shrink();
      }
    }
  
    shrink() {
      this.isClosing = true;
      const startHeight = `${this.el.offsetHeight}px`;
      const endHeight = `${this.summary.offsetHeight}px`;

      if (this.animation) {
        this.animation.cancel();
      }
      
      this.animation = this.el.animate({
        height: [startHeight, endHeight]
      }, {
        duration: 400,
        easing: 'ease-out'
      });
      
      this.animation.onfinish = () => this.onAnimationFinish(false);
      this.animation.oncancel = () => this.isClosing = false;
    }
  
    open() {
      this.el.style.height = `${this.el.offsetHeight}px`;
      this.el.open = true;
      window.requestAnimationFrame(() => this.expand());
    }
  
    expand() {
      this.isExpanding = true;
      const startHeight = `${this.el.offsetHeight}px`;
      const endHeight = `${this.summary.offsetHeight + this.content.offsetHeight}px`;
      
      if (this.animation) {
        this.animation.cancel();
      }
      
      // Start a WAAPI animation
      this.animation = this.el.animate({
        height: [startHeight, endHeight]
      }, {
        duration: 400,
        easing: 'ease-out'
      });
      this.animation.onfinish = () => this.onAnimationFinish(true);
      this.animation.oncancel = () => this.isExpanding = false;
    }
  
    onAnimationFinish(open) {
      this.el.open = open;
      this.animation = null;
      this.isClosing = false;
      this.isExpanding = false;
      this.el.style.height = this.el.style.overflow = '';
    }
  }
  
  document.querySelectorAll('details.collapsible-tab').forEach((el) => {
    new Accordion(el);
  });
})();